import { render } from "./ServiceTargets.vue?vue&type=template&id=3cab8a6a"
import script from "./ServiceTargets.vue?vue&type=script&lang=js"
export * from "./ServiceTargets.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__